"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _moment = _interopRequireDefault(require("moment"));

var _FormatMetric = _interopRequireDefault(require("./FormatMetric.messages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FormatMetric extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "formatInteger", () => {
      let value = this.props.value;

      if (this.context.intl) {
        return _react.default.createElement(_reactIntl.FormattedNumber, {
          value: value
        });
      }

      value = new Intl.NumberFormat('de-DE').format(value);
      return value;
    });

    _defineProperty(this, "formatFloat", () => {
      let _this$props = this.props,
          value = _this$props.value,
          decimals = _this$props.decimals;

      if (this.context.intl) {
        return _react.default.createElement(_reactIntl.FormattedNumber, {
          value: value,
          minimumFractionDigits: 2,
          maximumFractionDigits: decimals
        });
      }

      value = parseFloat(value).toFixed(decimals);
      value = new Intl.NumberFormat('de-DE').format(value);
      return value;
    });

    _defineProperty(this, "formatPercent", () => {
      let _this$props2 = this.props,
          value = _this$props2.value,
          decimals = _this$props2.decimals;
      value = parseFloat(value).toFixed(decimals) + "%";
      return value;
    });

    _defineProperty(this, "formatTime", () => {
      let value = this.props.value;
      value = (0, _moment.default)().startOf('day').add(value, "seconds").format('HH:mm:ss');
      return value;
    });

    _defineProperty(this, "formatDuration", () => {
      let value = this.props.value;
      var sec_num = parseInt(value, 10);
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours) {
        return hours + 'h ' + minutes + 'm ' + seconds + 's';
      }

      if (minutes) {
        return minutes + 'm ' + seconds + 's';
      }

      return seconds + 's';
    });

    _defineProperty(this, "formatValue", () => {
      const _this$props3 = this.props,
            type = _this$props3.type,
            value = _this$props3.value,
            decimals = _this$props3.decimals;

      if (type === "INTEGER") {
        return this.formatInteger();
      }

      if (type === "FLOAT") {
        return this.formatFloat();
      }

      if (type === "PERCENT") {
        return this.formatPercent();
      }

      if (type === "TIME") {
        return this.formatTime();
      }

      if (type === "DURATION") {
        return this.formatDuration();
      }

      return value;
    });

    _defineProperty(this, "formatName", () => {
      const name = this.props.name;

      if (_FormatMetric.default[name]) {
        return _FormatMetric.default[name];
      }

      return name;
    });
  }

  render() {
    const _this$props4 = this.props,
          name = _this$props4.name,
          type = _this$props4.type,
          value = _this$props4.value;

    if (value) {
      return this.formatValue();
    }

    if (name) {
      return this.formatName();
    }

    return null;
  }

}

_defineProperty(FormatMetric, "contextTypes", {
  intl: _propTypes.default.object
});

_defineProperty(FormatMetric, "defaultProps", {
  decimals: 2
});

FormatMetric.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.number,
  decimals: _propTypes.default.number
} : {};
var _default = FormatMetric;
exports.default = _default;
module.exports = exports.default;